import { ServiceOrderPreview } from '../serviceOrder.types';

type ServiceOrderBulkUpdateFormStepProps = {
    readonly validOrders: ServiceOrderPreview[];
};

export const ServiceOrderBulkUpdateFormStep = ({ validOrders }: ServiceOrderBulkUpdateFormStepProps) => {
    return (
        <div>
            <span>Hello</span>
            <span>{validOrders.map((order) => order.orderId)}</span>
        </div>
    );
};
